import React from "react";
import { SSH_FeatureHandler } from "../../../../helpers/FeatureHandler.helper";
import V1 from "./v1/ShortDescriptionV1.component";

const featureName = "blockPLPSeoShortDescription";
const versions = {
    v1: V1,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const SSH_SeoShortDescription = React.forwardRef(({ version, ...props }: any, ref: any) => (
    <SSH_FeatureHandler
        featureName={featureName}
        featureVersions={versions}
        version={version}
        {...props}
    />
));

SSH_SeoShortDescription.displayName = "SSH_SeoShortDescription";
